import { jsx as i } from "react/jsx-runtime";
import { createContext as f, forwardRef as s, useMemo as g, useContext as l } from "react";
import * as r from "@radix-ui/react-tabs";
import { twMerge as n } from "tailwind-merge";
const d = f({
  variant: "none"
}), c = s(
  ({ children: a, className: o, variant: e = "none", ...t }, p) => {
    const u = g(
      () => ({
        variant: e
      }),
      [e]
    );
    return /* @__PURE__ */ i(d.Provider, { value: u, children: /* @__PURE__ */ i(r.Root, { className: o, ref: p, ...t, children: a }) });
  }
);
c.displayName = r.Root.displayName;
const m = s(
  ({ className: a, ...o }, e) => {
    const { variant: t } = l(d);
    return /* @__PURE__ */ i(
      r.List,
      {
        ref: e,
        className: n(
          "flex flex-wrap items-stretch",
          t === "none" && "rounded-xl bg-gray-100 p-1",
          t === "underline" && "border-b border-gray-200",
          a
        ),
        ...o
      }
    );
  }
);
m.displayName = r.List.displayName;
const x = s(
  ({ className: a, ...o }, e) => {
    const { variant: t } = l(d);
    return /* @__PURE__ */ i(
      r.Trigger,
      {
        ref: e,
        className: n(
          "group flex flex-1 items-center justify-center",
          "radix-disabled:cursor-not-allowed radix-disabled:opacity-50",
          t === "none" && [
            "whitespace-normal px-4 py-2 text-center",
            "h-auto min-h-10 flex-1 rounded-lg bg-transparent",
            "text-base font-medium text-gray-600",
            "radix-state-active:bg-white radix-state-active:text-black radix-state-active:drop-shadow-sm"
          ],
          t === "bordered" && [
            "px-4 py-2 text-gray-900",
            "border border-gray-300",
            "-ml-px first:ml-0",
            "first:rounded-l-md",
            "last:rounded-r-md",
            "radix-state-active:relative radix-state-active:z-10",
            "radix-state-active:border-blue-500 radix-state-active:bg-blue-25",
            "radix-state-active:font-medium radix-state-active:text-blue-700"
          ],
          t === "underline" && [
            "gap-2 border-b-2 border-b-transparent p-4 font-medium",
            "radix-state-active:border-b-blue-500 radix-state-active:text-blue-500"
          ],
          a
        ),
        ...o
      }
    );
  }
);
x.displayName = r.Trigger.displayName;
const b = s(
  ({ className: a, ...o }, e) => /* @__PURE__ */ i(
    r.Content,
    {
      ref: e,
      className: n("mt-4 focus:outline-none", a),
      ...o
    }
  )
);
b.displayName = r.Content.displayName;
const T = c, h = m, w = x, C = b;
export {
  C as Content,
  h as List,
  T as Root,
  b as TabsContent,
  m as TabsList,
  c as TabsRoot,
  x as TabsTrigger,
  w as Trigger
};
